import { useReducer, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from "../../../../hooks";
import countryList from "../data/countries";
import { initialState, reducer } from "../reducers";
import { generalEventRegistrationService } from "../../../../services";
const {
  digitalSkillsregistrationDetails,
  attendanceOptions,
  eventCode,
  eventName,
  organizer,
} = require("../data");

const countries = countryList.map(({ name }) => name);

// Function to validate email
const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

// Function to validate phone number (assuming 10-digit phone)
const validatePhone = (phone) => {
  return String(phone).match(/^[0-9]{10}$/);
};

// Required fields for the form
const requiredFields = ["fullname", "phone", "emailAddress"];

const useDigitalSkillsTraining = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isLoading, setIsLoading] = useState(false);
  const [hasRegistered, setHasRegistered] = useState();
  const [registrationStatus, setRegistrationStatus] = useState();
  const [isRegistrationLimitReached, setIsRegistrationLimitReached] =
    useState(true);
  // const [location, setLocation] = useState();
  const { themeContext, theme } = useTheme();
  const history = useHistory();

  //! NEW FLOW
  const [regionSelected, setRegionSelected] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [modeOfAttendance, setModeOfAttendanceLocal] = useState("");

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const [token, setToken] = useState(null);

  // Handle input change and validation
  const handleChange = (key, value) => {
    const payload = {};
    let updatedErrors;
    const { errors } = state;

    // Validate required fields
    if (requiredFields.includes(key)) {
      if (!value || value.trim() === "") {
        updatedErrors = errors.includes(key) ? errors : [...errors, key];
      } else {
        updatedErrors = errors.filter((err) => err !== key);
      }
      payload["errors"] = updatedErrors;
    }

    payload[key] = value;
    dispatch({
      type: "update",
      payload,
    });
  };

  // Validate the form
  const validateForm = () => {
    let updatedErrors = [];

    // Validate fullName
    if (!state.fullname || state.fullname.trim() === "") {
      updatedErrors.push("fullname");
    }

    // Validate phone
    if (!state.phone || !validatePhone(state.phone)) {
      updatedErrors.push("phone");
    }

    // Validate email
    if (!state.emailAddress && !validateEmail(state.emailAddress)) {
      updatedErrors.push("emailAddress");
    }

    // Dispatch the updated errors
    dispatch({
      type: "update",
      payload: {
        errors: updatedErrors,
      },
    });

    // Return true if there are no errors
    return updatedErrors.length < 1;
  };

  // Submit form after validation
  const submitForm = () => {
    setIsLoading(true);
    const payload = {
      eventName,
      eventCode,
      organizer,
      registrationData: {
        ...state,
        regionSelected,
        selectedLocation,
        modeOfAttendance,
      },
    };
    const token = JSON.parse(localStorage.getItem("token"));
    generalEventRegistrationService
      .submitRegistrationData(token, payload)
      .then((data) => {
        setRegistrationStatus(data);
      })
      .catch((e) => {
        console.log("error submitting event registration form -> ", e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getRegistrationStatus = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    setIsLoading(true);
    generalEventRegistrationService
      .getRegistrationDetails(token, eventCode)
      .then((data) => {
        const { registrationDetails } = data || {};
        if (registrationDetails) {
          setHasRegistered(true);
        } else setHasRegistered(false);
      })
      .catch(() => {
        // TODO: Handle error
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getRegistrationStatus();
  }, []);

  const getNumRegisteredParticipants = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    setIsLoading(true);
    generalEventRegistrationService
      .getNumRegisteredParticipants(token, eventCode)
      .then((data) => {
        const { numRegisteredParticipants } = data?.data || {};
        if (
          numRegisteredParticipants >=
          digitalSkillsregistrationDetails.maxParticipants
        ) {
          setIsRegistrationLimitReached(true);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log("error -> ", e);
      });
  };
  // Check registration status on component mount
  useEffect(() => {
    getRegistrationStatus();
    getNumRegisteredParticipants();
  }, []);

  // Get token from localStorage
  useEffect(() => {
    const t = JSON.parse(localStorage.getItem("token"));
    setToken(t);
  }, []);

  return {
    background,
    history,
    digitalSkillsregistrationDetails,
    attendanceOptions,
    state,
    handleChange,
    submitForm,
    validateForm,
    countries,
    token,
    isLoading,
    hasRegistered,
    registrationStatus,
    isRegistrationLimitReached,

    regionSelected,
    setRegionSelected,
    selectedLocation,
    setSelectedLocation,
    modeOfAttendance,
    setModeOfAttendanceLocal,
  };
};

export default useDigitalSkillsTraining;
